import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import { setBacklink } from "../../redux/backlinkSlice";
import { useEffect, useState } from "react";

const CartButton = ({ productsAmount }) => {
    // Imposto il backlink prima di rimandare alla pagina carrello
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(setBacklink("/shop"));
        navigate("/cart");
    }

    // Calcolo la quantità totale di prodotti prima di passarla al carrello
    const { data } = useSelector(state => state.cart);
    const [totalProducts, setTotalProducts] = useState(null);
    const [isShow, setIsShow] = useState(false);
    const getTotal = () => {
        let total = 0;
        data.forEach(element => {
            total += element.quantity
        });
        setTotalProducts(total);
        setIsShow(true); // mostro un'evidenza al button
    }
    useEffect(() => {
        if (data) {
            getTotal();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])
    useEffect(() => {
        setTimeout(() => {
            setIsShow(false)
        }, 2000)
    }, [isShow])
    return (
        <button className={`fixed bottom-[88px] right-4 z-50 py-2 px-4 border border-neutral-300 rounded-xl flex gap-2 bg-white hover:bg-[#e2eeed] lg:static lg:mb-8 ${isShow && 'font-bold'}`} onClick={handleClick}>
            <div className="pt-0.5"><i className="fi fi-rr-shopping-cart"></i></div>
            <div>Carrello {totalProducts && <span className="text-[#225424]">({totalProducts})</span>}</div>
        </button>
    )
}

export default CartButton